import React, { forwardRef, memo, useCallback } from 'react';
import { Page } from 'react-pdf';
import { cn } from '../_lib/utils';

const PdfPage = forwardRef(({ page, height, zoomScale, isPageInView, isPageInViewRange }, ref) => {
  // Detect iOS
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  
  // On iOS, be very aggressive about limiting DPR to prevent rendering crashes
  const getDevicePixelRatio = useCallback(() => {
    if (isIOS) {
      // iOS has severe limitations - use 1.0 for normal viewing
      // Only increase for zoomed in viewing
      if (isPageInView && zoomScale > 2.5) {
        return 1.5;
      }
      return 1;
    }
    
    // Desktop/Android: normal behavior
    const baseDpr = window.devicePixelRatio || 1;
    if (isPageInView && zoomScale > 1.7) {
      return Math.min(zoomScale * baseDpr, 5);
    }
    
    return baseDpr;
  }, [isPageInView, zoomScale, isIOS]);

  const handleRenderError = (error) => {
    console.error(`Error rendering PDF page ${page}:`, error);
    if (isIOS) {
      console.error('❌ iOS page render failed:', { page, error });
    }
  };

  return (
    <div 
      ref={ref} 
      className={cn(page % 2 === 0 ? 'bg-background' : 'bg-muted')} 
      style={{ 
        background: '#000',
        minHeight: height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        WebkitUserSelect: 'none'
      }}
    >
      {isPageInViewRange && (
        <Page
          devicePixelRatio={getDevicePixelRatio()}
          height={height}
          pageNumber={page}
          canvasBackground={'#000'}
          renderAnnotationLayer={true}
          renderTextLayer={false}
          loading={<></>}
          error={<></>}
          onRenderError={handleRenderError}
          scale={1}
        />
      )}
    </div>
  );
});

PdfPage.displayName = 'PdfPage';
export default memo(PdfPage);
